import type { SVGProps } from 'react'

export const Sale = (props: SVGProps<SVGSVGElement>) => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <g clipPath="url(#clip0_220_16536)">
      <path
        d="M8.75822 3.05312C9.4207 2.31311 10.5793 2.31311 11.2418 3.05312L11.8257 3.70542C12.1633 4.08256 12.6541 4.28583 13.1595 4.25789L14.0337 4.20956C15.0254 4.15473 15.8446 4.97398 15.7898 5.96568L15.7415 6.83985C15.7135 7.34527 15.9168 7.836 16.2939 8.17362L16.9462 8.75758C17.6862 9.42005 17.6862 10.5786 16.9462 11.2411L16.2939 11.8251C15.9168 12.1627 15.7135 12.6534 15.7415 13.1588L15.7898 14.033C15.8446 15.0247 15.0254 15.844 14.0337 15.7891L13.1595 15.7408C12.6541 15.7129 12.1633 15.9161 11.8257 16.2933L11.2418 16.9456C10.5793 17.6856 9.42069 17.6856 8.75822 16.9456L8.17426 16.2933C7.83664 15.9161 7.34591 15.7129 6.8405 15.7408L5.96632 15.7891C4.97462 15.844 4.15537 15.0247 4.2102 14.033L4.25853 13.1588C4.28647 12.6534 4.0832 12.1627 3.70606 11.8251L3.05376 11.2411C2.31375 10.5786 2.31375 9.42005 3.05376 8.75758L3.70606 8.17362C4.0832 7.83599 4.28647 7.34527 4.25853 6.83985L4.2102 5.96568C4.15537 4.97398 4.97462 4.15473 5.96632 4.20956L6.8405 4.25789C7.34591 4.28583 7.83664 4.08256 8.17426 3.70542L8.75822 3.05312Z"
        stroke="currentColor"
      />
      <rect
        x="7.91666"
        y="7.91602"
        width="0.00833333"
        height="0.00833333"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinejoin="round"
      />
      <rect
        x="12.0833"
        y="12.084"
        width="0.00833333"
        height="0.00833333"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinejoin="round"
      />
      <path d="M12.5 7.5L7.5 12.5" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" />
    </g>
    <defs>
      <clipPath id="clip0_220_16536">
        <rect width="20" height="20" fill="white" />
      </clipPath>
    </defs>
  </svg>
)
